const parallaxElements = document.querySelectorAll('.parallax img');

if (parallaxElements.length) {
  let ticking = false;

  const update = () => {
    const y = window.scrollY * -0.2;
    for (const element of parallaxElements) {
      element.style.transform = `translateY(${y}px) scale(1.4)`;
    }
    ticking = false;
  };

  document.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    },
    { passive: true }
  );
}
